import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";

import reducers from "@App/state/reducers/index";

// add redux devtools
const composeEnhancers =
  (window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] as typeof compose) || compose;

export const store = createStore(reducers, {}, composeEnhancers(applyMiddleware(thunk)));
